/**
 * "You are not looking at all of it" — the sentence a capped result (§5.1, §5.7) has to say for
 * itself, or the last row reads as the end of the data. Phrased as a fact plus the fix (§4.10) and
 * deliberately not styled as an error: nothing failed, and red sends people hunting a fault.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScissors } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '@/lib/i18n';

export function TruncationNotice() {
  const { text } = useI18n();
  return (
    <div
      role="status"
      className="flex items-start gap-2.5 rounded-lg border border-border bg-muted/40 p-3 text-sm"
    >
      <FontAwesomeIcon
        icon={faScissors}
        className="mt-0.5 size-3.5 shrink-0 text-muted-foreground"
        aria-hidden
      />
      <p className="text-muted-foreground">
        {text('This report returned more rows than can be shown, so the list below is incomplete and any figure read off it covers part of the period only.')}{' '}
        <span className="font-medium text-foreground">
          {text('Narrow the dates or add a filter to see the whole result')}
        </span>
        .
      </p>
    </div>
  );
}
